import { useAppSelector } from "@config/hooks";
import { EUserAccessRoles, EUserRoles } from "@models/user";
import { getAccessRoleFromUserRole } from "@utils/helpers";
import _ from "lodash";
import { PropsWithChildren } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { adminPaths, publicPaths } from "./routes";

type TAuthRouteProps = {
  accessRoles: EUserAccessRoles[];
};

function AuthRoute(props: PropsWithChildren<TAuthRouteProps>) {
  const { accessRoles, children } = props;
  const location = useLocation();
  const currentUser = useAppSelector((state) => state.auth.currentUser);
  const userAccessRole = getAccessRoleFromUserRole(currentUser?.role?.map((r) => r.roleCode as EUserRoles) ?? []  );

  if (currentUser && _.includes(accessRoles, userAccessRole)) {
    return children as JSX.Element;
  }

  const navigateProps = {
    replace: true,
    state: { from: location },
  };

  if (currentUser?.role) {
    return <Navigate to={adminPaths.home} {...navigateProps} />;
  }

  return <Navigate to={publicPaths.login} {...navigateProps} />;
}

export default AuthRoute;
